import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { addConversationTrainingLabel } from "./schema/add-conversation-training-label";
import { createCalendarEntry } from "./schema/calendar/create-calendar-entry";
import { deleteCalendarEntry } from "./schema/calendar/delete-calendar-entry";
import { listCalendarEntries } from "./schema/calendar/list-calendar-entries";
import { updateCalendarEntry } from "./schema/calendar/update-calendar-entry";
import { completeSelfServeOnboarding } from "./schema/complete-self-serve-onboarding";
import { completeSelfServeOnboardingV2 } from "./schema/complete-self-serve-onboarding-v2";
import { conciergeAnalytics } from "./schema/concierge-analytics";
import { createAbTest } from "./schema/create-ab-test";
import { createConciergeKnowledge } from "./schema/create-concierge-knowledge";
import { deleteConciergeKnowledge } from "./schema/delete-concierge-knowledge";
import { endAbTest } from "./schema/end-ab-test";
import { generateConciergeBehavior } from "./schema/generate-concierge-behavior";
import { getAbTest } from "./schema/get-ab-test";
import { getConciergeDashboardProductTableData } from "./schema/get-concierge-dashboard-product-table-data";
import { getConciergeGeneralSettings } from "./schema/get-concierge-general-settings";
import { getConciergeKnowledge } from "./schema/get-concierge-knowledge";
import { getConciergeResponse } from "./schema/get-concierge-response";
import { getConciergeSkillsSettings } from "./schema/get-concierge-skills-settings";
import { getConciergeContextSettings } from "./schema/get-context-settings";
import { getConversationById } from "./schema/get-conversation-by-id";
import { getConversationTrainingLabelsForTeam } from "./schema/get-conversation-training-labels-for-team";
import { getConversations } from "./schema/get-conversations";
import { getConversationsByIds } from "./schema/get-conversations-by-ids";
import { getDemoConciergeKnowledge } from "./schema/get-demo-concierge-knowledge";
import { getKnowledgeSourcesForMessage } from "./schema/get-knowledge-sources-for-message";
import { getProductSettings } from "./schema/get-product-settings";
import { getSuggestedKnowledge } from "./schema/get-suggested-knowledge";
import { getTeamConciergeKnowledge } from "./schema/get-team-concierge-knowledge";
import { getTotalAiResponseCount } from "./schema/get-total-ai-response-count";
import { iMessageChannelExperimentAnalytics } from "./schema/imessage-channel-experiment-analytics";
import { listAbTests } from "./schema/list-ab-tests";
import { scrapeConciergeKnowledge } from "./schema/scrape-concierge-knowledge";
import { setConciergeContextSettings } from "./schema/set-context-settings";
import { supportAnalytics } from "./schema/support-analytics";
import { textConciergeAnalytics } from "./schema/text-concierge-analytics";
import { updateConciergeGeneralSettings } from "./schema/update-concierge-general-settings";
import { updateConciergeKnowledge } from "./schema/update-concierge-knowledge";
import { updateConciergeSkillsSettings } from "./schema/update-concierge-skills-settings";
import { updateProductSettings } from "./schema/update-product-settings";
import { upsertDemoConciergeKnowledge } from "./schema/upsert-demo-concierge-knowledge";

export const rpcDefinition = {
  scrapeConciergeKnowledge,
  updateConciergeGeneralSettings,
  getConciergeGeneralSettings,
  getConciergeKnowledge,
  getConciergeSkillsSettings,
  updateConciergeSkillsSettings,
  getConversations,
  getConciergeContextSettings,
  setConciergeContextSettings,
  getConciergeDashboardProductTableData,
  getProductSettings,
  updateProductSettings,
  getConversationById,
  getConversationsByIds,
  generateConciergeBehavior,
  addConversationTrainingLabel,
  getConversationTrainingLabelsForTeam,
  createConciergeKnowledge,
  updateConciergeKnowledge,
  deleteConciergeKnowledge,
  getTeamConciergeKnowledge,
  getTotalAiResponseCount,
  getKnowledgeSourcesForMessage,
  getSuggestedKnowledge,
  getConciergeResponse,
  getDemoConciergeKnowledge,
  upsertDemoConciergeKnowledge,
  completeSelfServeOnboarding,
  completeSelfServeOnboardingV2,
  conciergeAnalytics,
  supportAnalytics,
  textConciergeAnalytics,
  iMessageChannelExperimentAnalytics,
  listAbTests,
  getAbTest,
  createAbTest,
  endAbTest,
  listCalendarEntries,
  createCalendarEntry,
  updateCalendarEntry,
  deleteCalendarEntry,
};

export type RedoConciergeRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
